import finalPrice from './finalPrice'
const GrayAndSonsBoxVideoId = 'SdhPWhhWW_w' // https://www.youtube.com/embed/
const GrayAndSonsBoxVideo = {
  title: 'Gray & Sons Box',
  url: `https://www.youtube.com/embed/${GrayAndSonsBoxVideoId}`,
  type: 'video'
}

export const hasGrayAndSonsBox = (product) => { 
  return product.item_category == 'Watch' && product.original_box !== '1' && finalPrice(product) >= 5000
}
export const grayAndSonsBoxVideos = (product) => {
  return hasGrayAndSonsBox(product) ? [GrayAndSonsBoxVideo] : []
}

